export const getAutocompleteService = (id, options) => {
  return new google.maps.places.Autocomplete( // eslint-disable-line no-undef
    document.getElementById(id),
    options,
  );
}
